import AmberFinLogo from './img/AmberFinLogo.png';
import HomePageImgEnterpriseOneWeb from './img/HomePageImgEnterpriseOneWeb.png';
import HomePageImgFamilyOneWeb from './img/HomePageImgFamilyOneWeb.png';
import revolut from './img/RevolutLogo.png';
import './App.css';
import { Button, Carousel, Col, ConfigProvider, Divider, Grid, Popover, Row, Steps, Typography } from 'antd';
import { BrowserRouter, NavLink, Routes } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import {
    BankOutlined,
    BookOutlined,
    FormOutlined,
    HomeOutlined,
    InfoCircleOutlined,
    LinkedinOutlined
} from "@ant-design/icons";
import Footer from "./Footer";


const { Title, Text } = Typography;

function Home() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    return (
        <>
            <Row style={{ marginBottom: isMobile ? 24 : 64 }}>
                <Col span={24}>
                    <div
                        style={{
                            textAlign: "center",
                            padding: isMobile ? 16 : 24,
                        }}>
                        <Title level={1}>
                            Amber Quality IT Services at Scale
                        </Title>

                        <Title level={4} style={{fontWeight: "normal"}}>
                            To start using our services and integrate it to your business just follow link below and we
                            {" "}<br />will get back to you in no time.
                        </Title>
                        <br />
                        <NavLink className={"menu"} to={'/services'}>
                    <Button size='large' color="default" variant="solid">
                        Learn More
                    </Button>
                </NavLink>
                    </div>
                </Col>
            </Row>
            <Row
                style={{
                    maxWidth: 1024,
                    margin: '0 auto',
                    padding: '0 12px'
                }}
            >
                <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    style={{ textAlign: "left", paddingRight: isMobile ? 0 : 16, paddingTop: isMobile ? 0 : 64, paddingBottom: isMobile ? 32 : 64 }}
                >

                    <Title
                        level={1}
                        style={{ marginBottom: 32 }}>
                        Cloud Architecture
                    </Title>

                    <Title level={3} style={{fontWeight: "normal"}}>Strategy & Architecture Design</Title>
                    <Text>Defining the target operating model, and platform roadmap to ensure scalable, secure, and cost-efficient cloud adoption.</Text>

                    <Title level={3} style={{fontWeight: "normal"}}>Migration & Modernization</Title>
                    <Text>Transition of applications and data to the cloud, re-platforming and containerization.</Text>

                    <Title level={3} style={{fontWeight: "normal"}}>Governance & Security Framework</Title>
                    <Text>Establishes policies, controls, and security practices for identity, access, data protection, compliance, and cost management.</Text>
                </Col>
                <Col 
                    xs={24} 
                    sm={24} 
                    md={12} 
                    lg={12}>
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgFamilyOneWeb})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: isMobile ? "380px" : "600px",
                        position: "relative",
                    }}>
                        <h1
                            className={"amber-font"}
                            style={{
                                position: "absolute",
                                fontSize: isMobile ? 32 : 50,
                                bottom: isMobile ? 24 : 64, left: isMobile ? 24 : 80, right: isMobile ? 24 : undefined,
                                textShadow: "1px 1px 2px #000",
                                color: "#FFF"
                            }}>
                            IT Solutions
                            <small style={{ fontSize: isMobile ? 18 : 24, display: "block" }}>Small & Medium Business</small> </h1>
                    </div>
                </Col>
            </Row>

            <Row
                style={{
                    maxWidth: 1024,
                    margin: isMobile ? '32px auto' : '96px auto 96px auto',
                    padding: '0 12px'
                }}
            >
                <Col 
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                >

                    <div>
                        <div style={{
                            borderRadius: 24,
                            backgroundImage: `url(${HomePageImgEnterpriseOneWeb})`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            height: isMobile ? "380px" : "600px",
                            position: "relative",
                        }}>
                            <h1
                                className={"amber-font"}
                                style={{
                                    position: "absolute",
                                    fontSize: isMobile ? 30 : 50,
                                    top: 0,
                                    left: isMobile ? 24 : 60, right: isMobile ? 24 : undefined,
                                    textShadow: "1px 1px 2px #000",
                                    color: "#FFF"
                                }}>Enterprise Solutions</h1>

                            <h1
                                className={"amber-font"}
                                style={{
                                    position: "absolute",
                                    fontSize: isMobile ? 20 : 32,
                                    bottom: 24, left: isMobile ? 24 : 50, right: isMobile ? 24 : undefined,
                                    textShadow: "1px 1px 2px #000",
                                    color: "#FFF"
                                }}>Security, Scalability & Resilience</h1>
                        </div>
                    </div>
                </Col>
                <Col 
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    style={{
                    textAlign: "center"
                }}>
                    <div style={{ maxWidth: 592, width: "100%" }}>
                        <Row style={{padding: isMobile ? '32px 0 0 0' : '48px 0'}}>
                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={12} 
                                style={{ minHeight: isMobile ? 0 : 184, marginBottom: isMobile ? 24 : 0, }}
                            >
                                <Title level={3}>Security</Title>
                                <Text>Finacial privacy and security <br /> on a global scale</Text>
                            </Col>
                            <Col xs={24}
                    sm={24}
                    md={12}
                    lg={12} style={{ minHeight: isMobile ? 0 : 184, marginBottom: isMobile ? 24 : 0}}>
                                <Title level={3}>Scale</Title>
                                <Text>Our services & Solutions provide unlimited <br />scale for your business</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}
                    sm={24}
                    md={12}
                    lg={12} style={{ minHeight: isMobile ? 0 : 184, marginBottom: isMobile ? 24 : 0, paddingTop: 0 }}>
                                <Title level={3}>Resiliance</Title>
                                <Text>AI driven data analysis and <br />for sales</Text>
                            </Col>
                            <Col xs={24}
                    sm={24}
                    md={12}
                    lg={12} style={{ minHeight: isMobile ? 0 : 184, marginBottom: isMobile ? 24 : 0, paddingTop: 0 }}>
                                <Title level={3}>Regulations</Title>
                                <Text>Regulatory compliance out <br /> of the box</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}
                    sm={24}
                    md={12}
                    lg={12} style={{ minHeight: isMobile ? 0 : 184, marginBottom: isMobile ? 24 : 0, paddingTop: 0 }}>
                                <Title level={3} className={"amber-font-title"}>Sales Force</Title>
                                <Text>AI driven data analysis and <br />for sales</Text>
                            </Col>
                            <Col xs={24}
                    sm={24}
                    md={12}
                    lg={12} style={{ minHeight: isMobile ? 0 : 184, marginBottom: isMobile ? 24 : 0, paddingTop: 0 }}>
                                <Title level={3} className={"amber-font-title"}>Compliant by Design</Title>
                                <Text>Regulatory compliance <br /> out of the box</Text>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <Row className={'page-row'} style={{ margin: isMobile ? "32px auto 48px auto" : "64px auto 80px auto", maxWidth: 1024, }}>
                <Col span={24}>
                    <div
                        className={"amber-font"}
                        style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: 24,
                        }}>
                        <img src={AmberFinLogo} style={{ maxWidth: '36px', marginBottom: isMobile ? 32 : 64 }} alt={''} />
                    

                        <Row>
                            <Col
                                xs={24}
                                sm={24}
                                md={8}
                                lg={8}
                            >
                                <p><HomeOutlined /> Address</p>
                                <p style={{ marginTop: 32 }}>Lvivo g. 89-32, LT-08104 Vilnius</p>
                            </Col>
                            <Col
                                xs={24}
                                sm={24}
                                md={8}
                                lg={8}
                            >
                                <p><BookOutlined /> Company code</p>
                                <p style={{ marginTop: 32 }}>307504792</p>

                            </Col>
                            <Col
                                xs={24}
                                sm={24}
                                md={8}
                                lg={8}
                            >
                                <p><BankOutlined /> Bank</p>
                                <div style={{ width: "252px", margin: '0 auto' }}>
                                    <img
                                        src={revolut}
                                        style={{
                                            maxWidth: '68px',
                                            float: 'left',
                                        }}
                                    />
                                    <p style={{ display: 'inline-block', float: 'left' }}>LT32 3250 0726 8950 5637</p>
                                    <div style={{ clear: "both" }}></div>
                                </div>
                                <div style={{ clear: "both" }}>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default Home;
